import { Helmet } from 'react-helmet-async';

/**
 * AdminSEO Component
 * 
 * Dedicated SEO component for admin/protected pages that:
 * 1. Sets noindex, nofollow to prevent search engine indexing
 * 2. Uses a separate admin-specific title format
 * 3. Never includes public site branding in metadata
 * 4. Prevents any admin content from leaking to search engines
 */
const AdminSEO = ({ title = 'Admin Dashboard' }) => {
  // Admin pages should NEVER use public site metadata
  const adminTitle = `${title} | UPA Admin`;
  
  return (
    <Helmet>
      {/* Critical: Prevent indexing of admin pages */}
      <meta name="robots" content="noindex, nofollow, noarchive, nosnippet" />
      <meta name="googlebot" content="noindex, nofollow" />
      
      {/* Admin-specific title - separate from public branding */}
      <title>{adminTitle}</title>
      
      {/* Prevent caching of admin pages */}
      <meta http-equiv="Cache-Control" content="no-cache, no-store, must-revalidate" />
      <meta http-equiv="Pragma" content="no-cache" />
      <meta http-equiv="Expires" content="0" />
      
      {/* No open graph or social sharing for admin pages */}
      <meta property="og:title" content="" />
      <meta property="og:description" content="" />
      <meta property="og:image" content="" />
      <meta name="twitter:card" content="" />
      <meta name="twitter:title" content="" />
      <meta name="twitter:description" content="" />
      
      {/* Remove any canonical that might point to public pages */}
      <link rel="canonical" href="" />
    </Helmet>
  );
};

export default AdminSEO;
